export const CampaignStatus = {
  Active: 'Active',
  Sold: 'Sold',
  Withdrawn: 'Withdrawn',
} as const;

export type CampaignStatus = (typeof CampaignStatus)[keyof typeof CampaignStatus];

export function isCampaignStatus(value: string): value is CampaignStatus {
  return Object.values(CampaignStatus).includes(value as CampaignStatus);
}

export const SourceListingStatus = {
  Active: 'Active',
  ActiveUnderContract: 'ActiveUnderContract',
  Backup: 'Backup',
  Cancelled: 'Cancelled',
  Closed: 'Closed',
  ComingSoon: 'ComingSoon',
  Contingent: 'Contingent',
  Deleted: 'Deleted',
  Expired: 'Expired',
  Hold: 'Hold',
  OffMarket: 'OffMarket',
  Pending: 'Pending',
  Withdrawn: 'Withdrawn',
} as const;

export type SourceListingStatus = (typeof SourceListingStatus)[keyof typeof SourceListingStatus];

export const CampaignCategory = {
  Rental: 'Rental',
  Sale: 'Sale',
} as const;

export type CampaignCategory = (typeof CampaignCategory)[keyof typeof CampaignCategory];

export const CampaignType = {
  Residential: 'Residential',
  Rental: 'Rental',
  Commercial: 'Commercial',
} as const;

export type CampaignType = (typeof CampaignType)[keyof typeof CampaignType];
